'use strict';

/**
 * Handles displaying a toast message based on the response from the server.
 * @param {string} msgType - The type of message to display ('success' or 'failure').
 * @param {string} msg - The message to display.
 * @param {boolean} [stacked=false] - If true, multiple toasts will be stacked on top of each other.
 */
function handleToast(msgType, msg, stacked) {
    if ($('.py-toast-container').length === 0) {
        $('body').append('<div class="py-toast-container"></div>');
    }

    if (!stacked) {
        if (window.toastTimeout) {
            clearTimeout(window.toastTimeout);
        }
        $('.py-toast-container').empty();
    }

    // Create unique ID for each toast
    const toastId = 'toast-' + Date.now() + '-' + Math.floor(Math.random() * 1000);
    const toastClass = 'py-' + msgType + '-toast';
    const $toast = $(`<div class="py-toast-section" id="${toastId}"><div class="${toastClass}">${msg}</div></div>`);

    $('.py-toast-container').append($toast);
    const timeout = setTimeout(() => {
        $(`#${toastId}`).fadeOut(300, function () {
            $(this).remove();
        });
    }, 3000);

    if (!stacked) {
        window.toastTimeout = timeout;
    }
}

$('body').on('successToast', function (e, msg, stacked) {
    handleToast('success', msg, stacked);
});

$('body').on('failureToast', function (e, msg, stacked) {
    handleToast('faliure', msg, stacked);
});
